import type { PropsWithChildren } from 'react'

import { usePageStatus } from 'modules/layout/components/ResponsivePage/FactorialOnePage/usePageStatus'
import Content from 'modules/shift_management/components/ShiftManagement/Content'
import Layout from 'modules/shift_management/components/ShiftManagement/Layout'
import { useFilters } from 'modules/shift_management/hooks/useFilters'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import useNavigationSync from 'modules/shift_management/hooks/useNavigationSync'
import getStatusTagData from 'modules/shift_management/lib/getStatusTagData'

import useFetchDefaultShifts from './useFetchDefaultShifts'
import useFetchShiftsRows from './useFetchShiftsRows'
import useFetchStats from './useFetchStats'
import useFetchTemplateWeeks from './useFetchTemplateWeeks'

const MainPage = ({ children }: PropsWithChildren) => {
  useNavigationSync()
  useFetchShiftsRows()
  useFetchStats()
  // TODO: Move these queries to the proper place to do the query on demand,
  // like sidepanel, coverage section, etc
  useFetchDefaultShifts({})
  useFetchTemplateWeeks()

  const [{ shiftsRows }] = useShiftsRows()
  const [{ conflictsCount, hasDrafts }] = useSchedule()
  const [filters] = useFilters()

  const { statusTag, statusVariant, statusLabel } = getStatusTagData({
    shiftsRows,
    conflictsCount,
    hasDrafts,
    filters,
  })
  const { setPageStatus } = usePageStatus()
  setPageStatus({ text: statusTag, variant: statusVariant, tooltip: statusLabel })

  return (
    <Layout>
      <Content />
      {children}
    </Layout>
  )
}

// I'm exporting this like this to make sure that we make the API of this
// component as explicit as possible and to try to enforce that the public
// interface it has is small.
export { MainPage }
